<template>
  <main id="authorAccountant" v-if="isAuthed">
    <Toolbars
      ref="toolbars"
      :status="getStatus"
      @emit="emitted"
    />
    <!-- <div id="legacy">
      <iframe name="legacyFrame" src=""></iframe>
      <form id="legacyForm" ref="legacyForm" target="legacyFrame" action="https://legacy.sasmango.com/sas/author/cdiv?status=process" method="POST">
        <input type="hidden" name="firebaseToken" ref="legacyToken" value="" />
      </form>
    </div> -->
    <v-list dense class="py-0 transparent clients body" :three-line="!$vuetify.breakpoint.smAndUp">
      <v-list-item class="px-0 mx-3" v-if="$vuetify.breakpoint.smAndUp">
        <v-row>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.mdAndDown }]">引出日</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.mdAndDown }]">支払先/顧客名</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.mdAndDown }]">金額種類/利用内容</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.mdAndDown }]">未・振分額</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.mdAndDown }]">済・振分額</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.mdAndDown }]">勘定科目名</v-col>
        </v-row>
      </v-list-item>
      <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'" />
      <template v-for="item in getItems">
        <v-list-item class="px-0 it-hv mx-3" :key="item.id" :data-id="item.id" @click="open(item)">
          <v-row v-if="$vuetify.breakpoint.smAndUp">
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.date }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.name }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.type }}</v-col>
            <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.process }}</v-col>
            <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.done }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.item }}</v-col>
          </v-row>
          <v-list-item-content v-else>
            <v-list-item-subtitle class="caption">{{ `${item.item}/${item.type}` }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
            <v-list-item-title class="body-1">
              <span class="font-weight-bold">未：</span><span>{{ item.process }}</span>
              <span class="font-weight-bold ml-2">済：</span><span>{{ item.done }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.id + '_div'"></v-divider>
      </template>
    </v-list>
    <Editor
      ref="editor"
      :item="getTargetItem"
      @done="update"
    />
  </main>
</template>

<script>
import Toolbars from './toolbars'
import Editor from './modals/edit'
const DEF = {
  LOADING: false,
  FILTERED: false,
  LIMIT: 20,
  ORDER: {
    FIELD: 'date',
    DIR: 'desc'
  }
}
const ICONS = {
  ORDER: {
    DIR: {
      ASC: ['fal', 'sort-numeric-down'],
      DESC: ['fal', 'sort-numeric-up']
    }
  }
}
export default {
  name: 'authorAccountant',
  components: {
    Toolbars,
    Editor
  },
  data () {
    return {
      config: {
        status: {
          authed: false,
          loading: DEF.LOADING
        }
      },
      meta: {
        types: {
          payments: 'お引出金額',
          prefunds: 'お引出金額',
          deposites: 'お預入れ金額',
          drefunds: 'お預入れ金額',
          commissions: 'お預入れ金額'
        },
        items: {
          drefunds: '預り金（返金）',
          prefunds: '預り金（返金）',
          dcrefunds: '預り金（%%ITEM%%返金）',
          dcpayments: '預り金 %%ITEM%%',
          payments: '預り金',
          deposites: '預り金',
          commissions: '預り金（C）'
        }
      },
      form: {
        order: {
          field: DEF.ORDER.FIELD,
          dir: DEF.ORDER.DIR,
          icon: ICONS.ORDER.DIR[DEF.ORDER.DIR.toUpperCase()]
        }
      },
      store: {
        target: '',
        items: [],
        clients: {},
        companies: {},
        children: {}
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
      // this.$nextTick(() => {
      //   this.loadLegacy()
      // })
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (fm) {
      if (fm) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}accountant/get/items`, {
            form: {
              date: fm.date,
              area: fm.area,
              status: fm.status
            },
            limit: {
              offset: fm.limit.offset,
              size: fm.limit.size
            },
            order: {
              field: this.form.order.field,
              dir: this.form.order.dir
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              const { items, clients, companies, children, count } = res.data.data
              this.$set(this.store, 'items', items)
              this.$set(this.store, 'clients', clients)
              this.$set(this.store, 'companies', companies)
              this.$set(this.store, 'children', children)
              this.$refs.toolbars.count(count)
            }
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (req) {
      const { id } = req || {}
      if (id) {
        let idx = this.store.items.findIndex(it => { return it.id === id })
        if (idx >= 0) {
          this.$set(this.store, 'target', id)
          this.$nextTick(() => {
            this.$refs.editor.open()
          })
        }
      }
    },
    update: function () {
      if (this.$refs.toolbars) {
        this.$refs.toolbars.search()
      }
    },
    loadLegacy: function () {
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.$refs.legacyToken.value = token
        this.$nextTick(() => {
          this.$refs.legacyForm.submit()
        })
      })
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    isLoading () {
      return this.config.status.loading
    },
    isItemEmpty () {
      return this.store.items.length === 0
    },
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    printOrderField () {
      return this.form.order.field
    },
    printOrderDirectionIcon () {
      return this.$mango.order.icons.dir[this.form.order.dir] ? this.$mango.order.icons.dir[this.form.order.dir] : []
    },
    getStatus () {
      return this.config.status
    },
    getTargetItem () {
      let idx = this.store.items.findIndex(it => { return it.id === this.store.target })
      if (idx >= 0) {
        const { cid } = this.store.items[idx]
        return Object.assign({}, this.store.items[idx], {
          client: this.store.clients[cid] || this.store.companies[cid] || {}
        })
      } else {
        return ''
      }
    },
    getItems () {
      const { card, dcmeta } = this.$mango.bbook
      const { clients, companies, children } = this.store
      return this.store.items.length ? this.store.items.map(it => {
        const { id, cid, date, sum, type, label, value } = it || {}
        const done = children[id] ? children[id].reduce((prev, current, i, arr) => {
          return prev + (parseInt(isFinite(current.sum) ? current.sum : '0'))
        }, 0) : 0
        return {
          id,
          date: this.$moment(it.date).format('YYYY/MM/DD'),
          name: clients[cid] ? clients[cid].name.replace(',', ' ') : (companies[cid] ? companies[cid].name : ''),
          type: this.meta.types[type] || (['dcpayments', 'dcrefunds'].includes(type) ? dcmeta.labels[label] : label),
          process: `¥${(sum ? parseInt(sum) : 0) - done}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          done: `¥${done}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          item: this.meta.items[type].replace('%%ITEM%%', card.options[value].label) || ''
        }
      }) : []
    }
  }
}
</script>

<style lang="scss">
#authorAccountant {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
